import React from 'react';
import styled from 'styled-components';

const FacilitySection = styled.section`
  padding: 80px 0;
  background-color: #f0f9ff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const FacilityDescription = styled.p`
  text-align: center;
  color: #555;
  font-size: 16px;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto 50px;
  padding: 0 20px;
`;

const GalleryContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const GalleryItem = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  
  &:nth-child(3n+1) {
    grid-row: span 2;
  }
  
  @media (max-width: 992px) {
    &:nth-child(3n+1) {
      grid-row: span 1;
    }
    
    &:nth-child(2n+1) {
      grid-row: span 2;
    }
  }
  
  @media (max-width: 576px) {
    &:nth-child(2n+1) {
      grid-row: span 1;
    }
  }
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const Button = styled.a`
  display: inline-block;
  background-color: #ff6f00;
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #ff9100;
  }
`;

const Facility = () => {
  const galleryImages = [
    { id: 1, src: '/facility/reception.jpg', alt: 'Recepção colorida e acolhedora' },
    { id: 2, src: '/facility/playroom.jpg', alt: 'Espaço de brincadeiras' },
    { id: 3, src: '/facility/treatment-room.jpg', alt: 'Consultório odontológico infantil' },
    { id: 4, src: '/facility/waiting-area.jpg', alt: 'Área de espera para pais' },
    { id: 5, src: '/facility/equipment.jpg', alt: 'Equipamentos modernos' },
    { id: 6, src: '/facility/decoration.jpg', alt: 'Decoração temática infantil' },
  ];

  return (
    <FacilitySection id="estrutura">
      <SectionTitle>Nossa Estrutura</SectionTitle>
      <SectionSubtitle>
        Um ambiente projetado para o conforto e diversão dos pequenos pacientes
      </SectionSubtitle>
      <Divider />
      
      <FacilityDescription>
        Conheça nossa clínica com uma estrutura ampla e acolhedora. Nosso espaço é projetado para proporcionar aconchego e segurança durante cada consulta. A recepção é colorida e alegre, oferecendo uma área confortável para os pais e um ambiente lúdico para seus filhos com jogos, livros e atividades. Contamos com consultórios modernos e equipados com tecnologia avançada, decorados com temas infantis para criar um ambiente confortável e acolhedor. Isso sem esquecer das nossas Salas de Conforto, ambientes reservados para os pais que precisam de privacidade e para o pós-operatório infantil.
      </FacilityDescription>
      
      <GalleryContainer>
        <Gallery>
          {galleryImages.map(image => (
            <GalleryItem key={image.id}>
              <GalleryImage src={image.src} alt={image.alt} />
            </GalleryItem>
          ))}
        </Gallery>
      </GalleryContainer>
      
      <ButtonContainer>
        <Button href="/agendar">Agendar consulta</Button>
      </ButtonContainer>
    </FacilitySection>
  );
};

export default Facility;
